module.exports = __webpack_public_path__ + "static/media/download-white.fd7746b3.svg";